export const formatCurrency = value => {
	if ( value ) {
		return parseFloat( value ).toLocaleString(
			'en-us',
			{
				style: 'currency',
				currency: 'USD'
			}
		);
	}

	return '';
};

export const formatCurrencyInput = value => {
	if ( value ) {
		return parseFloat( value ).toFixed( 2 );
	}

	return '';
};

export const unformatCurrencyInput = value => {
	if ( value ) {
		return parseFloat( value );
	}

	return '';
};
